import { action, computed, makeObservable, observable } from 'mobx';
import { JobSkill } from 'jobs/types';
import { MultiSelectViewModel } from 'shared/components';
export class SkillsViewModel {
   readonly multiselect: MultiSelectViewModel<JobSkill>;

   readonly skillsOptions = observable.array<JobSkill>([]);
   query: string = '';
   constructor(value: any, options: { onValueChange?: (values: JobSkill[]) => void } = {}) {
      makeObservable(this, {
         results: computed,
         setOptions: action.bound,
      });

      this.multiselect = new MultiSelectViewModel<JobSkill>(undefined, {
         getLabel: (item) => item.name,
         onValueChange: options.onValueChange,
      });
   }

   setOptions(skills: JobSkill[]): void {
      this.skillsOptions.replace(skills);
   }

   get results(): JobSkill[] {
      return this.skillsOptions.filter((skill) =>
         skill.name.toLocaleLowerCase().includes(this.multiselect.search.trim().toLocaleLowerCase())
      );
   }

   clear(): void {
      this.query = '';
   }
}
